namespace('compass.hotel');

compass.hotel.GroupHotelPictureSummaryTileWidget = compass.defineWidget(function GroupHotelPictureSummaryTileWidget(options) {
	var me = this;
	var $j = jQuery;
	var _settings = options;
	var _WUID = _settings.WUID;
	var _defaultImage = compass.staticPrefix + "/resources/img/compass/hotel/nomainimage.jpg";

	/* accessibilty structure */
	var accessibilty = {
		TAB_INDEX: 0
	};

	var _setupControls = this.setupControls = function() {

	};

	var _render = this.render = function(widgetElem) {
		var d = _d;
		jQuery.map(_settings.reservationsArray, function(n) {
			widgetElem.append(me.drawHotelTile(n));
		});
		_setupControls();
	};

	this.drawHotelTile = function(resObj) {
		var d = _d;

		var hotelTile = d.div({className:'tileWrapper tile', tabindex: accessibilty.TAB_INDEX, 'aria-role' : 'button', role : 'button'},
			d.div({className:'hotelImage', style :
				{ 'background-image' : 'url(' + encodeURI(resObj.hotelInfo.hotelImage.length > 0 ? resObj.hotelInfo.hotelImage : _defaultImage) + ')' } }),
			me.drawHotelStayInfo(resObj)
		);
		
		hotelTile.activate(function() {
			me.trigger('GroupHotelPictureSummaryTileWidget.Modify'); 
		});
		
		return hotelTile;
	};

	this.drawHotelStayInfo = function(hotelInfoObj) {
		var d = _d;

		var editLink = d.div({ className : 'linkToRes' }, 
			d.div({ className : 'linkCopy' }, "Edit / Review &raquo;")
		);

		return d.div({className:'hotelStayInfo'},
			d.div({className: 'reservationBannerDiv'},
				d.div({ className : 'reservationBanner' },
					d.span('Group Hotel ',
					d.span({ className : 'groupHotelCount' }, (_settings.currentHotel) + ' of ' + _settings.totalHotels))
				),
				d.div({ className : 'northWestTriangle' })
			),
			d.div({className:'hotelInfo'},
				d.div({className: 'infoWrapper'},
					d.div({className:'hotelName'},hotelInfoObj.hotelInfo.hotelName + (hotelInfoObj.hotelInfo.GDS ? ' (Web Rate Hotel)' : '')),
					d.div({className: 'stayDetails'},hotelInfoObj.hotelInfo.numberOfRooms + ' Rooms: ' + hotelInfoObj.hotelInfo.numberOfAssignedRooms + ' Assigned, ' + (hotelInfoObj.hotelInfo.numberOfRooms - hotelInfoObj.hotelInfo.numberOfAssignedRooms) + ' Unassigned')
				),
				editLink,
				d.div({className : 'endHotelInfo'})
			),
			d.div({className:'endHotelStayInfo'})
		);
	};

	var _d = jQuery.dom.getContext(this);

}, {
	WUID : 'defaultHotelPictureSummaryTileWidgetWUID',
	widgetName : 'GroupHotelPictureSummaryTileWidget',
	imgPath : '/resources/img',
	subclass : false,
	reservationsArray : [],
	currentHotel: 1,
	totalHotels: 1
});
